import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SettingsOutlined } from '@mui/icons-material';
import PropTypes from 'prop-types';
import useHandleActionClick from '../../helpers/usehandleActionClick';
import { filterBalances } from '../../../client/Juno/helpers';
import { useJunoCommonFunctions } from '../../../client/Juno/helpers';
import BalancesDetailsCard from '../junocards/BalancesDetailsCard';
import ManageCurrenciesCard from '../junocards/ManageCurrenciesCard';
import { defaultCurrenciesToDisplay } from '../../../client/Juno/helpers';
import { MODAL_COMPONENTS } from '../../helpers/constant';
import ManageCurrenciesModal from '../junocards/ManageCurrenciesModal';
import FrozenWalletCard from '../junocards/FrozenWalletCard';


const BalancesSection = ({ managedCurrencies, balancesData, actionIcons, isDashboard = true }) => {
    const [balances, setBalances] = useState([]);
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const [modalAction, setModalAction] = useState('');
    const [selectedBalanceData, setSelectedBalanceData] = useState({});
    const [manageModalState, setManageModalState] = useState(false);
    const kycStatus = useSelector(state => state.juno.clientData)?.kyc?.status;

    const handleActionClick = useHandleActionClick(kycStatus, setModalAction);
    const filteredBalancesData = filterBalances(balancesData);
    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();
    const navigate = useNavigate();

    useEffect(() => {
        if (balancesData) {
            if (managedCurrencies.length) {
                const data = balancesData?.filter(currency => {
                    return managedCurrencies?.includes(currency.currencyShortName);
                });
                setBalances(data);
            } else {
                setBalances(
                    balancesData.filter(balance => {
                        return defaultCurrenciesToDisplay.includes(balance.currencyShortName);
                    }),
                );
            }
        }
    }, [balancesData, managedCurrencies]);

    const handleCloseModal = useCallback(() => setModalAction(''), []);

    const commonModalProps = {
        onClose: handleCloseModal,
        row: selectedBalanceData,
        selectCurrency: true,
        isModal: true,
        preSelected: selectedBalanceData,
        type: modalAction,
    };

    const ModalComponent = MODAL_COMPONENTS[modalAction];

    const onCloseManageDrawer = () => {
        setManageModalState(false);
    };

    const onCardClick = currency => {
        windowWidth < 1100 && navigate(`/client/balances/${currency}`);
    };

    return (
        <>
            <div
                className={`!p-1 bg-rootStyle-bg rounded-tr-xl rounded-tl-xl ${!isDashboard && 'h-full'
                    }`}>
                {ModalComponent && (
                    <ModalComponent
                        key={`${modalAction}-${selectedBalanceData?.currencyShortName || 'default'}`}
                        open={true}
                        selectedBalance={selectedBalanceData}
                        balanceCurrency={filteredBalancesData}
                        {...commonModalProps}
                    />
                )}
                <div
                    className={`p-3 flex justify-between lg:hidden ${!isDashboard &&
                        ' bg-actionBar-bg rounded-bl-lg rounded-br-lg border-b border-black/10 '
                        }  `}>
                    <div
                        className={`self-stretch justify-start text-section-title  text-sm font-semibold`}>
                        BALANCES
                    </div>
                    <div
                        onClick={() => {
                            setManageModalState(true);
                        }}>
                        <SettingsOutlined className="text-section-title" />
                    </div>
                </div>
                <div className="flex flex-wrap">
                    {isDashboard && (
                        <ManageCurrenciesCard setManageModalState={setManageModalState} />
                    )}
                    {balances?.map(item => {
                        const isFrozen = item.isFreeze;
                        return (

                            <div
                                key={item?.currencyShortName}
                                className="relative max-h-[270px] w-full md:w-1/2 lg:w-1/3 px-[2px] mb-1"
                            >
                                <div className="relative h-full overflow-hidden rounded-lg">
                                    <div className={isFrozen ? "!filter !blur-[24px] pointer-events-none" : ""}>
                                        <BalancesDetailsCard
                                            item={item}
                                            imageBaseUrl={imageBaseUrl}
                                            actionIcons={actionIcons}
                                            handleActionClick={handleActionClick}
                                            setSelectedBalanceData={setSelectedBalanceData}
                                            onCardClick={onCardClick}
                                        />
                                    </div>
                                    {isFrozen && (
                                        <div className="absolute inset-0 z-10">
                                            <FrozenWalletCard
                                                title={`${item?.currencyShortName} WALLET FROZEN`}
                                                description="This wallet has been frozen, for assistance."
                                                onContactSupport={()=>{}}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <ManageCurrenciesModal
                balancesData={filteredBalancesData}
                open={manageModalState}
                onClose={onCloseManageDrawer}
            />
        </>
    );
};

BalancesSection.propTypes = {
    managedCurrencies: PropTypes.array.isRequired,
    balancesData: PropTypes.array.isRequired,
    actionIcons: PropTypes.array.isRequired,
    isDashboard: PropTypes.bool.isRequired,
};

export default BalancesSection;
